<template>
    <div class="info">
        <template v-if="types">
            <div>
                <span
                    v-for="type in types"
                    class="small label mr-1"
                    :style="labelColor">
                    {{ type.name }}
                </span>
            </div>
        </template>
        <div
            v-else
        >
            <span
                class="small label mr-1"
                :style="labelColor">
                    {{ type }}
                </span>
        </div>
        <div class="title">
            <v-clamp autoresize :max-lines="3">
                {{ title }}
            </v-clamp>
        </div>
        <div class="date">
            {{ date }}
        </div>
    </div>
</template>

<script>
import ScreenSize from "../../../mixins/screen-size";
import VClamp from "vue-clamp";

export default {
    name: "Caption",
    mixins: [ScreenSize],
    components: {
        VClamp
    },
    props: {
        title: '',
        date: '',
        type: '',
        types: null,
        labelColor: {
            '--color': 'transparent',
            '--color-hover': '#ffffff'
        }
    }
}
</script>
